import React, { useState, useEffect, useContext } from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Spinner
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import CreatableSelect from "react-select/creatable";
// @ts-ignore
import ReactBSAlert from "react-bootstrap-sweetalert";
import EmpresaContext from "../../../../contexts/Empresa";
import api from "../../../../services/api";
import CardForm from "./CardForm";

interface Estagio {
  id?: number;
  estagio_id?: number;
  nome: string;
}

interface Funil {
  id: number | string;
  nome: string;
}

interface CardModalProps {
  isOpen: boolean;
  toggle: () => void;
  funilId?: number | string;
  estagios?: Estagio[];
  funis?: Funil[];
  card?: any;
  onSuccess: () => void;
  notify: (type: string, msg: string) => void;
}

const CardModal: React.FC<CardModalProps> = ({
  isOpen,
  toggle,
  funilId,
  estagios = [],
  funis,
  card,
  onSuccess,
  notify
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered modal-dialog-scrollable" size="lg" scrollable>
      <div className="modal-header">
        <h5 className="modal-title">{(card && card.id) ? 'Editar Card' : 'Novo Card'}</h5>
        <button type="button" className="close" onClick={toggle}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <CardForm
        card={card}
        funilId={funilId}
        estagios={estagios}
        funis={funis}
        onSuccess={() => {
          onSuccess();
          toggle();
        }}
        onCancel={toggle}
        notify={notify}
      />
    </Modal>
  );
};

export default CardModal;
